<!-- <mat-sidenav-container> -->
    <!-- <mat-sidenav #rightNav fixedInViewport style="width: 100px;"
      mode="side"  
      opened="true"
      position="end">

      <span style="align-items: flex-start; color: aliceblue; margin: 15px;">Temp...</span>
      
    </mat-sidenav> -->
    <!-- <mat-sidenav-content #rightNavContent style="padding: 0px !important;"> -->
        <mat-card appearance="outlined">
            <mat-card-header>
                <h2>Account</h2>
            </mat-card-header>
            <mat-card-content>
                Name: {{user.name}} <br />
                E-mail: {{user.email}}  <br />
                <mat-icon>verified_user</mat-icon> Autenticador TOTP ativo
            </mat-card-content>
        </mat-card>
    <!-- </mat-sidenav-content>
</mat-sidenav-container>  -->
